var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"text-center"},[_c('p',[_vm._v("Powered by Conexa Saúde / CNPJ 27.092.748/0001-18")])])}]

export { render, staticRenderFns }